import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    let cycleTimer: number | undefined;
    const show = () => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_FOR);
      cycleTimer = window.setTimeout(show, SHOW_FOR + GAP);
    };
    cycleTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 sm:inset-x-auto sm:bottom-6 sm:left-6" aria-live="polite" data-id="element-43" data-mp="116mhywpkww73">
      <AnimatePresence data-id="element-44" data-mp="1awzapc7jrvob">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(6,20,46,0.45)] ring-1 ring-navy-950/10 sm:w-[340px]" data-id="element-45" data-mp="1axhectwjhc69">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist object-contain" data-id="element-46" data-mp="28mkghr0s3r6j" />
            <div className="min-w-0" data-id="element-47" data-mp="23npmru19wi7n">
              <p className="text-[14px] leading-snug text-ink" data-id="element-48" data-mp="2apcq2viiitft">
                <span className="font-bold" data-id="element-49" data-mp="2fno1haoghc05">{buyer.name}</span> from <span className="font-bold" data-id="element-50" data-mp="2fmcw56fd3w6x">{buyer.country}</span> just purchased
                <span className="font-bold text-brand-dark" data-id="element-51" data-mp="2kmhg56fhb91w"> Dental Bleaching Blueprint™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[12px] font-semibold text-cta" data-id="element-52" data-mp="2pkiy1o1652bs">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="1rz4vj1svpbb8" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-mist hover:text-ink" aria-label="Close notification" data-id="element-54" data-mp="21wj7op7rrdxq">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="1e6f58l6bhk8b" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}